import {Card, Stack} from '@mui/material';
import {FlowEnum} from 'presentation/modules/booking/shared/constants/flowEnum';
import {AppointmentInfoList} from 'presentation/modules/booking/shared/ui/components/ConfirmationBooking/AppointmentInfoList';
import React from 'react';
import {TelehealthConfirmBookingButton} from '../TelehealthReviewBooking/components/TelehealthConfirmBookingButton';
import {useTelehealthReviewBookingNew} from './hooks/useTelehealthReviewBookingNew';
import {StyledContainer} from './styles';
import {TelehealthReviewBookingNewProps} from './types';

export function TelehealthReviewBookingNew({handlePrevStep}: TelehealthReviewBookingNewProps) {
	const {beneficiaryName, planName, providerName, specialtyName, date, hour} =
		useTelehealthReviewBookingNew();

	return (
		<StyledContainer>
			<Card elevation={0} sx={{borderRadius: 2, p: 3}}>
				<Stack gap={3}>
					<AppointmentInfoList
						beneficiaryName={beneficiaryName}
						planName={planName}
						providerName={providerName}
						specialtyName={specialtyName}
						date={date}
						hour={hour}
						flowType={FlowEnum.TELEHEALTH}
					/>
				</Stack>
			</Card>
			<TelehealthConfirmBookingButton handleBack={handlePrevStep} />
		</StyledContainer>
	);
}
